"use client";

import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { AuthResponse } from '../config/api';

export function useAuth() {
  const [user, setUser] = useState<AuthResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      // Проверяем, есть ли данные пользователя в localStorage
      // Только на клиенте
      if (typeof window === 'undefined') {
        console.log('[useAuth] Skipping on server');
        setIsLoading(false);
        return;
      }

      const savedUser = localStorage.getItem('user');
      console.log('[useAuth] Checking localStorage. Found:', !!savedUser);
      
      if (savedUser) {
        try {
          const userData = JSON.parse(savedUser);
          console.log('[useAuth] Parsed user data:', userData);
          setUser(userData);
        } catch (parseError) {
          console.error('Error parsing saved user data:', parseError);
          localStorage.removeItem('user');
          setUser(null);
          setError('Ошибка данных пользователя');
        }
      } else {
        console.log('[useAuth] No user in localStorage');
        setUser(null);
        setError(null); // Нет ошибки, просто пользователь не авторизован
      }
    } catch (err) {
      console.error('[useAuth] Error:', err);
      setError(err instanceof Error ? err.message : 'Ошибка авторизации');
      setUser(null);
    } finally {
      setIsLoading(false);
      console.log('[useAuth] Auth check completed');
    }
  };

  const logout = async () => {
    try {
      await apiService.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Очищаем данные пользователя из localStorage
      localStorage.removeItem('user');
      setUser(null);
      setError(null);
      // Перенаправляем на главную страницу
      window.location.href = '/';
    }
  };

  return {
    user,
    isLoading,
    error,
    logout,
    checkAuth
  };
}
